import { render, staticRenderFns } from "./CountryGoals.vue?vue&type=template&id=1dc0cee9&scoped=true"
import script from "./CountryGoals.vue?vue&type=script&lang=js"
export * from "./CountryGoals.vue?vue&type=script&lang=js"
import style0 from "./CountryGoals.vue?vue&type=style&index=0&id=1dc0cee9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0cee9",
  null
  
)

export default component.exports